import React from 'react'
import i18next from 'i18next'
import { Link } from '../utils/links'

const paginationSize = 2 // the maximum amount of numbers directly next to each side of the current page number

type PaginationLayoutProps = {
  currentPage: number
  totalPages: number
  toPage: (page: number) => string
}

export const PaginationLayout = (props: PaginationLayoutProps) => {
  const { currentPage, totalPages, toPage } = props
  if (totalPages <= 1) return <React.Fragment key={"no-pages"} />
  else {
    const paginationNumbers = []
    for (
      let pageNumber = currentPage - paginationSize;
      pageNumber <= currentPage + paginationSize;
      pageNumber++
    ) {
      if (pageNumber === currentPage)
        paginationNumbers.push(
          <React.Fragment key={pageNumber}>
            <li
              className="pagination__item pagination__item--current"
              key={`page-${pageNumber}`}
              aria-current="page"
            >
              <span className="pagination__link pagination__link--current">
                <span className="sr-text">{i18next.t('pagination:page')} </span>
                <span className="pagination__label">{pageNumber}</span>
              </span>
            </li>
            {currentPage != totalPages && (
              <li
                className="pagination__item pagination__mob-only"
                aria-hidden="true"
                key="/"
              >
                <span className="pagination__letter">/</span>
              </li>
            )}
          </React.Fragment>
        )
      else if (pageNumber > 0 && pageNumber <= totalPages)
        paginationNumbers.push(
          <React.Fragment key={pageNumber}>
            <li
              className={`pagination__item${
                pageNumber == totalPages ? ' pagination__item--last' : ''
              }`}
              key={`page-${pageNumber}`}
            >
              <Link className="pagination__link" url={toPage(pageNumber)}>
                <span className="sr-text">{i18next.t('pagination:page')} </span>
                <span className="pagination__label">{pageNumber}</span>
              </Link>
            </li>
          </React.Fragment>
        )
    }

    const NavigationClickable = (
      p: { label: string } & (
        | {
            kind: 'link'
            to: string
          }
        | {
            kind: 'button'
            disabled: boolean
          }
      )
    ) =>
      p.kind == 'link' ? (
        <Link className="pagination__button" url={p.to} title={p.label}>
          <span className="sr-text">{p.label}</span>
          <svg
            className="button__icon"
            width="6px"
            height="10px"
            aria-hidden="true"
          >
            <use xlinkHref="#icon--chevron" />
          </svg>
        </Link>
      ) : (
        <button
          className="pagination__button"
          disabled={p.disabled}
          title={p.label}
        >
          <span className="sr-text">{p.label}</span>
          <svg
            className="button__icon"
            width="6px"
            height="10px"
            aria-hidden="true"
          >
            <use xlinkHref="icon--chevron" />
          </svg>
        </button>
      )
    const Spacer = ({ kind }: { kind: 'left' | 'right' }) => (
      <li
        className="pagination__item"
        aria-hidden="true"
        key={`${kind}-spacer`}
      >
        <span className="pagination__letter">...</span>
      </li>
    )

    return (
      <nav
        className="pagination container--m gutter--m"
        aria-label={i18next.t('a11y:navLabelPagination')}
      >
        <ul className="pagination__list">
          {currentPage > 1 ? (
            <li className="pagination__item pagination__item--prev" key="prev">
              {/* <NavigationClickable  kind="link" to={toPage(currentPage - 1)} label={i18next.t('pagination:previousPage')} /> */}
              <NavigationClickable
                kind="link"
                to={toPage(currentPage - 1)}
                label="Vorige pagina"
              />
            </li>
          ) : (
            <li className="pagination__item pagination__item--prev" key="prev">
              {/* <NavigationClickable  kind="button" disabled={true} label={i18next.t('pagination:previousPage')} /> */}
              <NavigationClickable
                kind="button"
                disabled={true}
                label="Vorige pagina"
              />
            </li>
          )}

          {currentPage > paginationSize + 1 && (
            <li className="pagination__item" key={`page-${1}`}>
              <Link className="pagination__link" url={toPage(1)}>
                <span className="sr-text">{i18next.t('pagination:page')} </span>
                <span className="pagination__label">1</span>
              </Link>
            </li>
          )}

          {currentPage > paginationSize + 2 && <Spacer kind="left" />}

          {paginationNumbers}

          {currentPage + paginationSize + 1 < totalPages && (
            <Spacer kind="right" />
          )}

          {currentPage + paginationSize < totalPages && (
            <li
              className="pagination__item pagination__item--last"
              key={`page-${totalPages}`}
            >
              <Link className="pagination__link" url={toPage(totalPages)}>
                <span className="sr-text">{i18next.t('pagination:page')} </span>
                <span className="pagination__label">{totalPages}</span>
              </Link>
            </li>
          )}

          {currentPage == totalPages && (
            <>
              <li
                className="pagination__item pagination__mob-only"
                aria-hidden="true"
                key="last-/"
              >
                <span className="pagination__letter">/</span>
              </li>

              <li
                className="pagination__item pagination__mob-only"
                aria-hidden="true"
                key={`last-number`}
              >
                <span className="pagination__link">
                  <span className="pagination__label">{totalPages}</span>
                </span>
              </li>
            </>
          )}

          {currentPage < totalPages ? (
            <li className="pagination__item pagination__item--next" key="next">
              {/* <NavigationClickable  kind="link" to={toPage(currentPage + 1)} label={i18next.t('pagination:nextPage')} /> */}
              <NavigationClickable
                kind="link"
                to={toPage(currentPage + 1)}
                label="Volgende pagina"
              />
            </li>
          ) : (
            <li className="pagination__item pagination__item--next" key="next">
              {/* <NavigationClickable  kind="button" disabled={true} label={i18next.t('pagination:nextPage')} /> */}
              <NavigationClickable
                kind="button"
                disabled={true}
                label="Volgende pagina"
              />
            </li>
          )}
        </ul>
      </nav>
    )
  }
}
